import React from "react";
import { CachedDataProvider } from "@/contexts/CachedDataContext";

const ClientCache = ({ children }) => {
  return (
    <CachedDataProvider>
      {children}
    </CachedDataProvider>
  );
};

export default ClientCache;
